import TableLoading from "../../../Components/Loader/TableLoading";
import SVG from "../../../Components/SVG";
import ProfitGridCard from "./ProfitGridCard";

export default function ProfitGrid({ rows, accLoading, onWithdraw }) {
  if (accLoading) {
    return (
      <div className="w-full flex justify-center items-center gap-2">
        <p className="text-[#808080]">در حال بارگذاری</p>
        <TableLoading className="text-[#808080]" />
      </div>
    );
  }

  if (rows.length === 0) {
    return (
      <div className="w-full flex justify-center items-center flex-col gap-5">
        <p className="text-zi-text-light dark:text-zi-text-dark">
          حساب فاندد جهت برداشت سود ندارید
        </p>
        <SVG name="noData" classname="w-24 fill-cyan-500" />
      </div>
    );
  }

  return (
    <div className="w-full flex flex-col gap-4">
      {rows.map((row) => (
        <ProfitGridCard
          key={row.id}
          {...row}
          onWithdraw={() => onWithdraw(row)}
        />
      ))}
    </div>
  );
}
